import { extractDate } from 'utils/date-format';
import { StatusLead } from '../../const';
import i18next from 'i18next';
import moment from 'moment';

export const parseResponseLeadCustomerInfo = data => {
  if (data.RecordType?.Name === 'Business') {
    return {
      id: data.Id,
      leadType: data.RecordType?.Name,
      status:
        StatusLead[
          data.Status === 'Technical Call'
            ? 'TECHNICAL_CALL'
            : data.Status === 'Commercial Call'
            ? 'COMMERCIAL_CALL'
            : data.Status === 'Quotation'
            ? 'QUOTATION'
            : data.Status
        ],
      creatorEmail: data.creatorEmail,
      data: [
        {
          title: 'company_and_vehicle_info',
          innerData: [
            [
              {
                label: 'company_legal_name',
                value: data.Company
              },
              { label: 'email_placeholder', value: data.Email },
              {
                label: 'vat_number',
                value: data.Company_ValueAddedTax__c,
                labelFromBe: 'Company_ValueAddedTax__c'
              },
              {
                label: 'delivery_date',
                value: data.Vehicle_Delivery__c
                  ? moment(
                      extractDate(data.Vehicle_Delivery__c),
                      'DD/MM/YYYY'
                    ).format('DD/MM/YY')
                  : null,
                labelFromBe: 'Vehicle_Delivery__c'
              }
            ],
            [
              { label: 'address', value: data.Street, labelFromBe: 'Street' },
              {
                label: 'zip',
                value: data.PostalCode,
                labelFromBe: 'PostalCode'
              },
              {
                label: 'building_or_place_called',
                value: data.Building__c,
                labelFromBe: 'Building__c'
              }
            ],
            [
              {
                label: 'name',
                value: data.FirstName,
                labelFromBe: 'FirstName'
              },
              {
                label: 'surname',
                value: data.LastName,
                labelFromBe: 'LastName'
              }
            ],
            [
              {
                label: 'prefix',
                value: data.Prefix__c,
                labelFromBe: 'Prefix__c'
              },
              {
                label: 'phone_number',
                value: data.Phone,
                labelFromBe: 'Phone'
              },
              {
                label: 'prefix_secondary_phone',
                value: data.Prefix_Secondary_Phone__c,
                labelFromBe: 'Prefix_Secondary_Phone__c'
              },
              {
                label: 'secondary_phone',
                value: data.MobilePhone,
                labelFromBe: 'MobilePhone'
              }
            ]
          ]
        },
        {
          title: 'lead_created_by',
          innerData: [
            [
              {
                label: 'name_surname',
                value: data.creator
              },

              { label: 'company', value: data.creatorCompany },
              { label: 'phone', value: data.creatorPhone },
              { label: 'email_placeholder', value: data.creatorEmail },
              {
                label: 'creation_date',
                value:
                  data.CreatedDate && moment(data.CreatedDate).isValid()
                    ? moment(data.CreatedDate).format('DD/MM/YY')
                    : '-'
              }
            ]
          ]
        },
        {
          title: 'product_preferences',
          innerData: [
            data?.Product_of_Interest__c?.split(';')?.map((d, i) => ({
              label: 'product_preferences_placeholder',
              labelForProducts: `product_preferences_placeholder_${i}`,
              value: d,
              labelFromBe: 'Product_of_Interest__c'
            }))
          ]
        },
        {
          title: 'additional_note',
          innerData: [
            [
              {
                label: 'max_255_char',
                value: data.Note__c,
                labelFromBe: 'Note__c'
              }
            ]
          ]
        }
      ],
      leadHistory: data.leadHistory?.reverse() || []
    };
  }

  return {
    id: data.Id,
    leadType: data.RecordType.Name,
    status:
      StatusLead[
        data.Status === 'Technical Call'
          ? 'TECHNICAL_CALL'
          : data.Status === 'Commercial Call'
          ? 'COMMERCIAL_CALL'
          : data.Status === 'Quotation'
          ? 'QUOTATION'
          : data.Status
      ],
    productOfInterest: data.Product_of_Interest__c || '',
    creatorEmail: data.creatorEmail,
    data: [
      {
        title: 'customer_info',
        innerData: [
          [
            { label: 'name', value: data.FirstName },
            { label: 'surname', value: data.LastName },
            { label: 'email_placeholder', value: data.Email },
            {
              label: 'fiscal_code',
              value: data.Fiscal_Code__c,
              labelFromBe: 'Fiscal_Code__c'
            }
          ],

          [
            { label: 'address', value: data.Street, labelFromBe: 'Street' },
            { label: 'zip', value: data.PostalCode, labelFromBe: 'PostalCode' },
            { label: 'city', value: data.City, labelFromBe: 'City' }
          ],
          [
            {
              label: 'prefix',
              value: data.Prefix__c,
              labelFromBe: 'Prefix__c'
            },
            { label: 'phone_number', value: data.Phone, labelFromBe: 'Phone' },
            {
              label: 'prefix_secondary_phone',
              value: data.Prefix_Secondary_Phone__c,
              labelFromBe: 'Prefix_Secondary_Phone__c'
            },
            {
              label: 'secondary_phone',
              value: data.MobilePhone,
              labelFromBe: 'MobilePhone'
            }
          ]
        ]
      },
      {
        title: 'product_preferences',
        innerData: [
          data?.Product_of_Interest__c?.split(';')?.map((d, i) => ({
            label: 'product_preferences_placeholder',
            labelForProducts: `product_preferences_placeholder_${i}`,
            value: d,
            labelFromBe: 'Product_of_Interest__c'
          }))
        ]
      },
      {
        title: 'vehicle_info',
        innerData: [
          [
            {
              label: 'brand',
              value: data.Car_Brand__c,
              labelFromBe: 'Car_Brand__c'
            },
            {
              label: 'model',
              value: data.Type_of_Vehicle__c,
              labelFromBe: 'Type_of_Vehicle__c'
            },
            {
              label: 'delivery_date',
              value: data.Vehicle_Delivery__c
                ? moment(
                    extractDate(data.Vehicle_Delivery__c),
                    'DD/MM/YYYY'
                  ).format('DD/MM/YY')
                : null,
              labelFromBe: 'Vehicle_Delivery__c'
            },
            {
              label: 'vin',
              value: data.Vehicle_Identification_Number__c,
              labelFromBe: 'Vehicle_Identification_Number__c'
            }
          ]
        ]
      },
      {
        title: 'lead_created_by',
        innerData: [
          [
            {
              label: 'name_surname',
              value: data.creator
            },

            { label: 'company', value: data.creatorCompany },
            { label: 'phone', value: data.creatorPhone },
            { label: 'email_placeholder', value: data.creatorEmail },
            {
              label: 'creation_date',
              value:
                data.CreatedDate && moment(data.CreatedDate).isValid()
                  ? moment(data.CreatedDate).format('DD/MM/YY')
                  : '-'
            }
          ]
        ]
      },
      {
        title: 'additional_note',
        innerData: [
          [
            {
              label: 'max_255_char',
              value: data.Note__c,
              labelFromBe: 'Note__c'
            }
          ]
        ]
      }
    ],
    leadHistory: data.leadHistory?.reverse() || []
  };
};

export const loadCorrectPdf = () => {
  const currentLang = i18next.language;
  switch (currentLang) {
    case 'it':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/IT/Leaflet_ePro.pdf';
    case 'en':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/EN/Leaflet_ePro.pdf';
    case 'es':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/ES/Leaflet_ePro.pdf';
    case 'fr':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/FR/Leaflet_ePro.pdf';
    case 'de':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/DE/Leaflet_ePro.pdf';
    default:
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/EN/Leaflet_ePro.pdf';
  }
};

export const loadCorrectDoc = () => {
  const currentLang = i18next.language;
  switch (currentLang) {
    case 'it':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/IT/Privacy_Module_Template.docx';
    case 'en':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/EN/Privacy_Module_Template.docx';
    case 'es':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/ES/Privacy_Module_Template.docx';
    case 'fr':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/FR/Privacy_Module_Template.docx';
    case 'de':
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/DE/Privacy_Module_Template.docx';
    default:
      return 'https://f2mes-publicdocs-noprod.s3.eu-west-1.amazonaws.com/partnerportal/EN/Privacy_Module_Template.docx';
  }
};
